import { QuestionFileModel } from 'survey-core';

// Mock the QuestionFileModel prototype to have the storeDataAsText property set as false
let QuestionFileModel_prototype_mock = {
  storeDataAsText: false
}

Object.setPrototypeOf(QuestionFileModel_prototype_mock, QuestionFileModel.prototype);

QuestionFileModel.prototype = QuestionFileModel_prototype_mock;
